/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportGeneratorRequest } from './ReportGeneratorRequest';
import {
    ReportGeneratorRequestFromJSON,
    ReportGeneratorRequestFromJSONTyped,
    ReportGeneratorRequestToJSON,
    ReportGeneratorRequestToJSONTyped,
} from './ReportGeneratorRequest';
import type { ReportExportFormats } from './ReportExportFormats';
import {
    ReportExportFormatsFromJSON,
    ReportExportFormatsFromJSONTyped,
    ReportExportFormatsToJSON,
    ReportExportFormatsToJSONTyped,
} from './ReportExportFormats';
import type { ReportResponseTypes } from './ReportResponseTypes';
import {
    ReportResponseTypesFromJSON,
    ReportResponseTypesFromJSONTyped,
    ReportResponseTypesToJSON,
    ReportResponseTypesToJSONTyped,
} from './ReportResponseTypes';
import type { ReportTypes } from './ReportTypes';
import {
    ReportTypesFromJSON,
    ReportTypesFromJSONTyped,
    ReportTypesToJSON,
    ReportTypesToJSONTyped,
} from './ReportTypes';

/**
 * 
 * @export
 * @interface BucketReportGeneratorRequest
 */
export interface BucketReportGeneratorRequest extends ReportGeneratorRequest {
}



/**
 * Check if a given object implements the BucketReportGeneratorRequest interface.
 */
export function instanceOfBucketReportGeneratorRequest(value: object): value is BucketReportGeneratorRequest {
    return true;
}

export function BucketReportGeneratorRequestFromJSON(json: any): BucketReportGeneratorRequest {
    return BucketReportGeneratorRequestFromJSONTyped(json, false);
}

export function BucketReportGeneratorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BucketReportGeneratorRequest {
    return json;
}

export function BucketReportGeneratorRequestToJSON(json: any): BucketReportGeneratorRequest {
    return BucketReportGeneratorRequestToJSONTyped(json, false);
}

export function BucketReportGeneratorRequestToJSONTyped(value?: BucketReportGeneratorRequest | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

